import './CompanyInfo.css'
import { APP_CONFIG } from '../../../config/appConfig'

function CompanyInfo() {
    return (
        <div className="company-box">
            {/* <img 
                src={APP_CONFIG.APP_LOGO} 
                alt="Company Logo" 
                className="company-logo"
            /> */}
            <span className="app-name">{APP_CONFIG.APP_NAME}</span>
        </div>
    )
}

export default CompanyInfo


